import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarState {
  /** 侧边栏是否收缩（true: 64px，false: 264px） */
  collapsed: boolean
  /** 展开的菜单ID集合（用于二级菜单） */
  expandedMenus: Set<string>

  /** 切换侧边栏收缩状态 */
  toggleCollapsed: () => void
  /** 设置侧边栏收缩状态 */
  setCollapsed: (collapsed: boolean) => void
  /** 切换菜单展开状态 */
  toggleMenu: (menuId: string) => void
  /** 设置菜单展开状态 */
  setMenuExpanded: (menuId: string, expanded: boolean) => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      expandedMenus: new Set<string>(),

      toggleCollapsed: () =>
        set((state) => ({
          collapsed: !state.collapsed,
        })),

      setCollapsed: (collapsed) => set({ collapsed }),

      toggleMenu: (menuId) =>
        set((state) => {
          const newSet = new Set(state.expandedMenus)
          if (newSet.has(menuId)) {
            newSet.delete(menuId)
          } else {
            newSet.add(menuId)
          }
          return { expandedMenus: newSet }
        }),

      setMenuExpanded: (menuId, expanded) =>
        set((state) => {
          const newSet = new Set(state.expandedMenus)
          if (expanded) {
            newSet.add(menuId)
          } else {
            newSet.delete(menuId)
          }
          return { expandedMenus: newSet }
        }),
    }),
    {
      name: 'sidebar-storage',
      // 自定义序列化/反序列化 Set
      partialize: (state) => ({
        collapsed: state.collapsed,
        expandedMenus: Array.from(state.expandedMenus),
      }),
      merge: (persistedState: any, currentState) => ({
        ...currentState,
        ...persistedState,
        expandedMenus: new Set(persistedState.expandedMenus || []),
      }),
    }
  )
)
